/**
 * I18n Module - 国际化模块
 * Vue2版本 - 处理多语言切换和文本翻译
 */

import storage from './storage'

// 翻译字典
const translations = {
    ja: {
        // 网站标题
        'site.title': 'ゲーム取引プラットフォーム',

        // 导航栏
        'nav.home': 'ホーム',
        'nav.buy': '購入',
        'nav.sell': 'ゲームを売る',
        'nav.items': '通貨アイテム',
        'nav.user': 'ユーザー設定',
        'nav.profile': 'ユーザー設定',
        'nav.login': 'ログイン',
        'nav.register': '登録',
        'nav.logout': 'ログアウト',
        'nav.admin': '管理者',
        'nav.back.home': 'ホームに戻る',
        'nav.pleaseLogin': 'ログインしてください',
        'nav.accountFrozen': 'あなたのアカウントは凍結されています。サポートにお問い合わせください。',
        'nav.loginFailed': 'ログイン失敗',

        // 首页
        'home.welcome': 'ゲーム取引プラットフォームへようこそ',
        'home.description': '安全で便利なゲーム商品取引プラットフォーム',
        'home.buy': '購入',
        'home.sell': '売る',
        'home.noCustomerQRAlert': 'カスタマーサービスのQRコードの取得に失敗しました。後でもう一度お試しください。',
        'home.failedFetchQRCode': 'QRコードの取得に失敗しました。後でもう一度お試しください。',
        'home.fetchingQRCode': 'QRコードを取得中...',

        // 注册页面
        'title': 'アカウント登録',
        'username': 'ユーザー名',
        'password': 'パスワード',
        'submit': '登録',
        'rememberPassword': 'パスワードを記憶',
        'failedRetry': '登録失敗、再試行してください',
        'hasAccountText': 'アカウントをお持ちですか？',
        'passwordMin': 'パスワードは8文字以上である必要があります',
        'passwordValid': 'パスワードは有効です',
        'goLogin': 'ログインへ',
        'completeInfo': 'ユーザー名とパスワードを入力してください',
        'usernameEmpty': 'ユーザー名を入力してください',
        'usernameMin': 'ユーザー名は3文字以上である必要があります',
        'usernameMax': 'ユーザー名は20文字以内である必要があります',
        'usernameInvalid': 'ユーザー名は英字、数字、アンダースコアのみ使用可能です',
        'passwordEmpty': 'パスワードを入力してください',
        'passwordRule': '8文字以上で数字と英字を含む',
        'passwordOnlyAllowed': 'パスワードは英字と数字のみ使用可能です',
        'passwordNeedNumber': 'パスワードには数字が含まれている必要があります',
        'passwordNeedLetter': 'パスワードには英字が含まれている必要があります',
        'usernameAvailable': 'ユーザー名が利用可能',
        'usernameTaken': 'ユーザー名は既に使用されています',
        'registering': '登録中...',
        'success': '登録成功',
        'failed': '登録失敗',
        'fundPasswordRule': '8文字以上で数字と英字を含む',
        'fundPasswordHint': '出金時に使用されます。必ず覚えてください',
        

        // 登录页面
        'login.title': 'ログイン',
        'login.username': 'ユーザー名',
        'login.password': 'パスワード',
        'login.submit': 'ログイン',
        'login.noAccount': 'アカウントをお持ちでないですか？',
        'login.goRegister': '登録へ',
        'login.error': 'ユーザー名またはパスワードが間違っています',
        'login.retry': '後でもう一度お試しください',
        'login.completeInfo': 'ユーザー名とパスワードを入力してください',
        'login.success': 'ログイン成功',

        // 商品列表
        'products.title': '商品リスト',
        'products.noProducts': '商品がありません',
        'products.price': '価格',
        'products.searchPlaceholder': 'ゲーム名で検索...',
        'products.newest': '最新順',
        'products.priceLowToHigh': '価格の安い順',
        'products.priceHighToLow': '価格の高い順',
        'products.search': '検索',
        'products.empty': '商品が見つかりません',
        'products.emptySubtext': '新しい商品をアップロードしてみましょう',
        'products.upload': '商品をアップロード',
        'products.statusAvailable': '販売中',
        'products.statusSold': '売り切れ',
        'products.statusReserved': '予約済み',
        'products.statusCompleted': '取引完了',

        // 商品详情
        'productDetail.title': '商品詳細',
        'productDetail.name': 'ゲーム名',
        'productDetail.price': '価格',
        'productDetail.seller': '出品者',
        'productDetail.contact': '連絡先',
        'productDetail.lineQR': 'Line QRコード',

        // 商品上传
        'productUpload.title': '商品アップロード',
        'productUpload.name': 'ゲーム名',
        'productUpload.price': '価格(円)',
        'productUpload.image': 'ゲーム商品画像',
        'productUpload.lineQR': 'Line QRコード',
        'productUpload.submit': '送信',
        'productUpload.gameNameTitle': '販売中のゲーム商品',
        'productUpload.gameImformation': 'ゲーム情報',
        'productUpload.gameDescription': '商品の説明',

        // 商品详情页面
        'detail.back': '戻る',
        'detail.publishTime': '公開時間',
        'detail.productDescription': '商品説明',
        'detail.sellerInfo': '出品者情報',
        'detail.accountInfo': 'ゲーム情報',
        'detail.seller': '出品者',
        'detail.productStatus': '商品状態',
        'detail.statusAvailable': '販売中',
        'detail.statusSold': '売り切れ',
        'detail.statusReserved': '予約済み',
        'detail.statusUnknown': '不明',
        'detail.purchase': '購入',
        'detail.markAsCompleted': '取引完了',
        'detail.productNotFound': '商品が見つかりません',
        'detail.productNotFoundMessage': '指定された商品は存在しないか、削除されました',
        'detail.confirmPurchase': '{name}を{price}円で購入してもよろしいですか？',
        'detail.confirmComplete': '{name}を{price}円で取引完了としてよろしいですか？',
        'detail.completeSuccess': '取引完了しました！',
        'detail.completeFailed': '取引完了失敗',
        'detail.completeFailedRetry': '取引完了に失敗しました。後でもう一度お試しください',
        'detail.purchaseSuccess': '購入成功！',
        'detail.purchaseFailed': '購入失敗',
        'detail.purchaseFailedRetry': '購入に失敗しました。後でもう一度お試しください',
        'detail.unknownSeller': '不明な出品者',
        'detail.loadProductFailed': '商品詳細の読み込みに失敗しました',

        // 商品上传页面
        'product.editTitle': '商品編集',
        'product.uploadTitle': '商品アップロード',
        'product.editSubtitle': '商品情報を編集してください',
        'product.uploadSubtitle': '新しい商品をアップロードしてください',
        'product.name': 'ゲーム名',
        'product.nameHint': 'ゲーム名を入力してください',
        'product.nameRule': '100文字以内',
        'product.price': '価格(円)',
        'product.priceHint': '価格を入力してください',
        'product.priceRule': '0.01円以上',
        'product.description': '商品説明',
        'product.descriptionHint': '商品の詳細説明を入力してください',
        'product.descriptionRule': '500文字以内',
        'product.image': 'ゲーム商品画像',
        'product.imageHint': '商品画像を選択してください',
        'product.selectImage': '画像を選択',
        'product.reSelectImage': '画像を再選択',
        'product.imageFormatHint': 'JPG、PNG、GIF、WebPフォーマットをサポートし、最大5 MB',
        'product.submitting': 'アップロード中...',
        'product.updating': '更新中...',
        'product.nameRequired': 'ゲーム名は必須です',
        'product.priceInvalid': '価格は0.01円以上である必要があります',
        'product.imageRequired': '商品画像は必須です',
        'product.fillRequired': '必須項目をすべて入力してください',
        'product.canOnlyEditOwn': '自分の商品のみ編集できます',
        'product.notExist': '商品が存在しません',
        'product.loadFailed': '商品データの読み込みに失敗しました',
        'product.invalidImage': '無効な画像形式です',
        'product.imageTooLarge': '画像サイズが5MBを超えています',
        'product.imageReadFailed': '画像の読み込みに失敗しました',
        'product.gameUsername': 'ゲームアカウント',
        'product.gameUsernameHint': 'ゲームアカウントを入力してください',
        'product.gamePassword': 'ゲームパスワード',
        'product.gamePasswordHint': 'ゲームパスワードを入力してください',
        'product.gameUsernameRequired': 'ゲームアカウントは必須です',
        'product.gamePasswordRequired': 'ゲームパスワードは必須です',
        'product.descriptionRequired': '商品説明は必須です',
        'product.uploadSuccess': '商品のアップロードが成功しました',
        'product.updateSuccess': '商品の更新が成功しました',
        'product.imageFormatInvalid': '無効な画像形式です。JPG、PNG、GIF、WebPのみサポートしています',
        'product.removeImage': '画像を削除',

        // 温馨提示
        'tips.title': 'ご案内',
        'tips.reviewRequired': 'コミット後に管理者レビューが必要',
        'tips.updateReviewRequired': '変更後に再レビューが必要',
        'tips.ensureValid': '商品情報が実際に有効であることを確認してください',
        'tips.statusReset': '修正後の商品ステータスはレビュー対象にリセットされます',

        // 用户资料
        'profile.title': 'ユーザープロフィール',
        'profile.name': '名前',
        'profile.phone': '電話',
        'profile.bankAccount': '銀行口座',
        'profile.katakanaName': 'カタカナ名',
        'profile.address': '住所',
        'profile.balance': '残高',
        'profile.save': '保存',
        'profile.withdrawalSubmitted': '出金申請が提出されました',
        'profile.withdrawalFailed': '出金申請が失敗しました',

        // 用户资料页面
        'userProfile.title': 'ユーザープロフィール - ゲーム取引プラットフォーム',
        'userProfile.heading': 'ユーザープロフィール管理',
        'userProfile.balance': 'アカウント残高',
        'userProfile.withdraw': '出金申請',
        'userProfile.info': '個人情報',
        'userProfile.username': 'ユーザー名',
        'userProfile.fullName': '本名 *',
        'userProfile.fullNameHint': '出金時に確認が必要です',
        'userProfile.phone': '連絡先電話 *',
        'userProfile.phoneHint': '重要な通知に使用されます',
        'userProfile.bankAccount': '銀行口座 *',
        'userProfile.bankAccountHint': '出金時に使用されます',
        'userProfile.katakanaName': 'カタカナ名 *',
        'userProfile.katakanaNameHint': '本人確認に使用されます',
        'userProfile.address': '連絡先住所 *',
        'userProfile.addressHint': '郵送または連絡に使用されます',
        'profile.email': 'メールアドレス',
        'profile.emailPlaceholder': 'メールアドレスを入力してください',
        'profile.emailHelp': '重要な通知，受信に使用されます',
        'fundPassword': '資金パスワード *',
        'fundPasswordHelp': 'パスワードを覚えておいてください',
        'fundPasswordHint': '出金時に使用されます。必ず覚えてください',
        'fundPasswordSet': '資金パスワードは設定済みです',
        'fundPasswordSetHelp': '資金パスワードが正常に設定されています',
        'fundPasswordPlaceholder': '8桁以上の数字と英字のパスワードを入力',
        'withdrawal.amountRequired': '出金額を入力してください',
        'withdrawal.amountInvalid': '無効な金額です',
        'withdrawal.amountExceedsBalance': '金額は現在の残高を超えることはできません',
        'withdrawal.fundPasswordRequired': '資金パスワードを入力してください',
        'withdrawal.incorrectFundPassword': '誤った資金パスワードです',
        'userProfile.requiredNote': '* 必須項目は出金前に入力してください',
        'userProfile.save': 'プロフィールを保存',
        'userProfile.myProducts': 'マイ商品',
        'userProfile.noProducts': '商品がありません',
        'userProfile.withdrawalHistory': '出金履歴',
        'userProfile.noWithdrawals': '出金記録がありません',
        'userProfile.errors.realName': '本名は必須です',
        'userProfile.errors.username': 'ユーザー名は必須です',
        'userProfile.errors.email': 'メールアドレスは必須です',
        'userProfile.errors.phone': '連絡先電話は必須です',
        'userProfile.errors.bankAccount': '銀行口座は必須です',
        'userProfile.errors.bankName': '銀行名は必須です',
        'userProfile.errors.bankBranch': '銀行支店は必須です',
        'userProfile.errors.katakanaName': 'カタカナ名は必須です',
        'userProfile.errors.address': '連絡先住所は必須です',
        'userProfile.errors.fundPassword': '資金パスワードは必須です',
        
        // 提现
        'withdrawal.title': '出金申請',
        'withdrawal.amount': '出金額',
        'withdrawal.bankAccount': '銀行口座',
        'withdrawal.name': '口座名義',
        'withdrawal.submit': '申請を送信',
        'withdrawal.history': '出金履歴',
        'withdrawal.status': 'ステータス',
        'withdrawal.pending': '審査中',
        'withdrawal.approved': '承認済み',
        'withdrawal.rejected': '却下',

        // 提现页面
        'withdrawal.pageTitle': '出金申請',
        'withdrawal.accountInfo': 'アカウント情報',
        'withdrawal.currentBalance': '現在の残高：',
        'withdrawal.accountName': '口座名義：',
        'withdrawal.bankAccountNumber': '銀行口座：',
        'withdrawal.profileHint': 'アカウント情報を変更するには、',
        'withdrawal.profileLink': 'ユーザープロフィール',
        'withdrawal.applyTitle': '出金申請',
        'withdrawal.amountHint': '出金額を入力してください（最低1円）',
        'withdrawal.notice': '注意事項：',
        'withdrawal.enterAmount': '出金金額を入力してください',
        'withdrawal.enterFundPassword': '資金パスワードの入力',
        'withdrawal.notice1': '出金額は現在の残高を超えることはできません',
        'withdrawal.notice2': '申請後、審査プロセスに入ります',
        'withdrawal.notice3': '承認後、1〜3営業日以内に入金されます',
        'withdrawal.notice4': '却下された場合、金額はアカウント残高に戻ります',
        'withdrawal.noHistory': '出金記録がありません',

        // 管理员
        'admin.dashboard': '管理者ダッシュボード',
        'admin.users': 'ユーザー管理',
        'admin.products': '商品管理',
        'admin.withdrawals': '出金管理',
        'admin.notifications': '通知管理',
        'admin.totalUsers': '総ユーザー数',
        'admin.totalProducts': '総商品数',
        'admin.pendingReviews': '審査待ち数',
        'admin.dashboardTitle': '管理者ダッシュボード',
        'admin.pendingProducts': '審査待ち商品',
        'admin.pendingWithdrawals': '審査待ち出金',
        'admin.quickActions': 'クイックアクション',
        'admin.manageUsers': 'ユーザー管理',
        'admin.manageProducts': '商品管理',
        'admin.manageWithdrawals': '出金管理',
        'admin.manageNotifications': '通知管理',
        'admin.recentActivity': '最近のアクティビティ',
        'admin.noActivity': 'アクティビティ記録がありません',
        'admin.backToSite': 'サイトに戻る',

        // 用户管理
        'users.title': 'ユーザー管理',
        'users.username': 'ユーザー名',
        'users.name': '名前',
        'users.status': 'ステータス',
        'users.balance': '残高',
        'users.actions': '操作',
        'users.view': '表示',
        'users.freeze': '凍結',
        'users.unfreeze': '凍結解除',
        'users.active': '正常',
        'users.frozen': '凍結済み',
        'users.noUsers': 'ユーザーがいません',
        'users.phone': '電話',
        'users.userDetails': 'ユーザー詳細',

        // 商品管理
        'productsAdmin.title': '商品管理',
        'productsAdmin.name': 'ゲーム名',
        'productsAdmin.price': '価格',
        'productsAdmin.seller': '出品者',
        'productsAdmin.status': 'ステータス',
        'productsAdmin.actions': '操作',
        'productsAdmin.view': '表示',
        'productsAdmin.approve': '承認',
        'productsAdmin.reject': '却下',
        'productsAdmin.pending': '審査中',
        'productsAdmin.approved': '承認済み',
        'productsAdmin.rejected': '却下',
        'productsAdmin.filterStatus': 'ステータスフィルター：',
        'productsAdmin.allStatus': 'すべて',
        'productsAdmin.noProducts': '商品がありません',
        'productsAdmin.image': '画像',
        'productsAdmin.productDetails': '商品詳細',

        // 提现管理
        'withdrawalsAdmin.title': '出金管理',
        'withdrawalsAdmin.user': 'ユーザー',
        'withdrawalsAdmin.amount': '金額',
        'withdrawalsAdmin.bankAccount': '銀行口座',
        'withdrawalsAdmin.status': 'ステータス',
        'withdrawalsAdmin.actions': '操作',
        'withdrawalsAdmin.view': '表示',
        'withdrawalsAdmin.approve': '承認',
        'withdrawalsAdmin.reject': '却下',
        'withdrawalsAdmin.filterStatus': 'ステータスフィルター：',
        'withdrawalsAdmin.allStatus': 'すべて',
        'withdrawalsAdmin.noWithdrawals': '出金記録がありません',
        'withdrawalsAdmin.accountName': '口座名義',
        'withdrawalsAdmin.time': '申請時間',
        'withdrawalsAdmin.withdrawalDetails': '出金詳細',

        // 通知管理
        'notificationsAdmin.title': '通知管理',
        'notificationsAdmin.create': '通知作成',
        'notificationsAdmin.contentZh': '中国語コンテンツ',
        'notificationsAdmin.contentEn': '英語コンテンツ',
        'notificationsAdmin.submit': '公開',
        'notificationsAdmin.edit': '編集',
        'notificationsAdmin.delete': '削除',
        'notificationsAdmin.list': '通知リスト',
        'notificationsAdmin.noNotifications': '通知がありません',
        'notificationsAdmin.editTitle': '通知編集',

        // 通用
        'common.save': '保存',
        'common.cancel': 'キャンセル',
        'common.confirm': '確認',
        'common.delete': '削除',
        'common.edit': '編集',
        'common.view': '表示',
        'common.submit': '送信',
        'common.back': '戻る',
        'common.loading': '読み込み中...',
        'common.success': '操作成功',
        'common.error': '操作失敗',
        'common.required': '必須項目',

        // 错误消息
        'error.invalidInput': '無効な入力',
        'error.usernameExists': 'ユーザー名は既に存在します',
        'error.loginFailed': 'ログイン失敗',
        'error.insufficientBalance': '残高不足',
        'error.incompleteProfile': 'まずプロフィールを完成させてください',
        'error.fundPasswordRequired': 'まず資金パスワードを設定してください',
        'error.invalidImage': '無効な画像形式',
        'error.unauthorized': 'アクセス権限がありません',

        // Product Edit Messages
        'profile.productSold': 'この商品は既に販売済みで、編集できません',
        'profile.productRemoved': 'この商品は既に削除済みで、編集できません',
        'profile.completeProfileFirst': 'まずプロフィールを完成させてください',
        'profile.accountFrozen': 'あなたのアカウントは凍結されています。サポートにお問い合わせください',
        'profile.checkUserStatusFailedRetry': 'ユーザーステータスの確認に失敗しました。後でもう一度お試しください',
        'profile.completeProfileFirst': 'まずプロフィールを完成させてください',
        'profile.insufficientBalance': '残高が不足しています。アカウントをチャージしてください',
        'profile.fundPasswordRequired': '資金パスワードが必要です。まず資金パスワードを設定してください',
        'profile.withdrawalSubmitted': '出金申請が提出されました',
        'profile.withdrawalFailed': '出金申請が失敗しました',
        'profile.withdrawalFailedRetry': '出金申請に失敗しました。後でもう一度お試しください',
        'profile.deleteSuccess': '商品の削除に成功しました',
        'profile.deleteFailed': '商品の削除に失敗しました。後でもう一度お試しください',
        'profile.deleteFailedRetry': '商品の削除に失敗しました。後でもう一度お試しください',
        'profile.saveFailed': 'プロフィールの保存に失敗しました。',
        'profile.saveFailedRetry': 'プロフィールの保存に失敗しました。後でもう一度お試しください',

        // Custom Registration Error Messages
        'register.usernameInvalid': 'ユーザー名の形式が正しくありません。アルファベット、数字、アンダースコアのみ使用可能で、長さは3~20文字にしてください。',
        'register.usernameExists': 'ユーザー名は既に存在します',
        'register.passwordInvalid': 'パスワードの形式が正しくありません。8文字以上で、数字と英字を含めてください',
        'register.networkError': 'ネットワークエラーが発生しました。後でもう一度お試しください',
        'register.serverError': 'サーバーエラーが発生しました。後でもう一度お試しください',
        'register.unknownError': '登録に失敗しました。後でもう一度お試しください',
    },
    en: {
        // Site Title
        'site.title': 'Game Trading Platform',

        // Navigation
        'nav.home': 'Home',
        'nav.buy': 'Buy',
        'nav.sell': 'Sell Your Game',
        'nav.items': 'Currency Items',
        'nav.user': 'User Settings',
        'nav.profile': 'User Settings',
        'nav.login': 'Login',
        'nav.register': 'Register',
        'nav.logout': 'Logout',
        'nav.admin': 'Admin',
        'nav.back.home': 'Back to Home',
        'nav.pleaseLogin': 'Please login first',
        'nav.accountFrozen': 'Your account is frozen. Please contact support.',
        'nav.loginFailed': 'Login failed',

        // Home
        'home.welcome': 'Welcome to Game Trading Platform',
        'home.description': 'Safe and convenient game trading platform',
        'home.buy': 'Buy',
        'home.sell': 'Sell',
        'home.noCustomerQRAlert': 'Failed to fetch customer service QR code. Please try again later.',
        'home.failedFetchQRCode': 'Failed to fetch QR code. Please try again later.',
        'home.fetchingQRCode': 'Fetching QR code...',

        // Register
        'title': 'Register Account',
        'username': 'Username',
        'password': 'Password',
        'confirmPassword': 'Confirm Password',
        'submit': 'Register',
        'passwordMin': 'Password must be at least 8 characters',
        'passwordValid': 'Password is valid',
        'hasAccountText': 'Already have an account?',
        'goLogin': 'Go to Login',
        'completeInfo': 'Please enter username and password',
        'usernameEmpty': 'Please enter username',
        'usernameMax': 'Username cannot exceed 20 characters',
        'usernameInvalid': 'Username can only contain letters, numbers and underscores',
        'passwordEmpty': 'Please enter password',
        'passwordRule': '8+ chars with numbers and letters',
        'passwordNeedLetter': 'Password must contain letters',
        'usernameAvailable': 'Username is available',
        'usernameTaken': 'Username is already taken',
        'registering': 'Registering...',
        'success': 'Registration successful',
        'failed': 'Registration failed',
        'fundPasswordRule': '8+ chars with numbers and letters',
        'fundPasswordPlaceholder': 'Enter 8 or more digits and the alphabet password',
        'fundPassword': 'Fund Password',
        'fundPasswordHelp': 'Please remember the password',

        // Login
        'login.title': 'Login',
        'login.username': 'Username',
        'login.password': 'Password',
        'login.submit': 'Login',
        'login.noAccount': 'No account?',
        'login.goRegister': 'Go to Register',
        'login.error': 'Incorrect username or password',
        'login.retry': 'Please try again later',
        'login.completeInfo': 'Please enter username and password',
        'login.success': 'Login successful',

        // Products
        'products.title': 'Products',
        'products.noProducts': 'No products available',
        'products.price': 'Price',
        'products.searchPlaceholder': 'Search by Game name...',
        'products.newest': 'Newest',
        'products.priceLowToHigh': 'Price: Low to High',
        'products.priceHighToLow': 'Price: High to Low',
        'products.search': 'Search',
        'products.empty': 'No products found',
        'products.emptySubtext': 'Try uploading new products',
        'products.upload': 'Upload Product',
        'products.statusAvailable': 'Available',
        'products.statusSold': 'Sold',
        'products.statusReserved': 'Reserved',
        'products.statusCompleted': 'Transaction completed',

        // Product Detail
        'productDetail.title': 'Product Detail',
        'productDetail.name': 'Game Name',
        'productDetail.price': 'Price',
        'productDetail.seller': 'Seller',
        'productDetail.contact': 'Contact',
        'productDetail.lineQR': 'Line QR Code',

        // Product Upload
        'productUpload.title': 'Upload Product',
        'productUpload.name': 'Game Name',
        'productUpload.price': 'Price',
        'productUpload.image': 'Game product Image',
        'productUpload.lineQR': 'Line QR Code',
        'productUpload.submit': 'Submit',
        'productUpload.gameNameTitle': 'Games on Sale',
        'productUpload.gameImformation': 'Game Information',
        'productUpload.gameDescription': 'Product Description',

        // Product Detail Page
        'detail.back': 'Back',
        'detail.publishTime': 'Publish Time',
        'detail.productDescription': 'Product Description',
        'detail.sellerInfo': 'Seller Info',
        'detail.accountInfo': 'Game Info',
        'detail.seller': 'Seller',
        'detail.productStatus': 'Product Status',
        'detail.statusAvailable': 'Available',
        'detail.statusSold': 'Sold',
        'detail.statusReserved': 'Reserved',
        'detail.statusUnknown': 'Unknown',
        'detail.purchase': 'Purchase',
        'detail.markAsCompleted': 'Mark as Completed',
        'detail.productNotFound': 'Product Not Found',
        'detail.productNotFoundMessage': 'The specified product does not exist or has been deleted',
        'detail.confirmPurchase': 'Are you sure you want to purchase {name} for {price}?',
        'detail.confirmComplete': 'Are you sure you want to mark {name} for {price} as completed?',
        'detail.completeSuccess': 'Transaction Completed!',
        'detail.completeFailed': 'Transaction Completion Failed',
        'detail.completeFailedRetry': 'Transaction completion failed. Please try again later',
        'detail.purchaseSuccess': 'Purchase Successful!',
        'detail.purchaseFailed': 'Purchase Failed',
        'detail.purchaseFailedRetry': 'Purchase failed. Please try again later',
        'detail.unknownSeller': 'Unknown Seller',
        'detail.loadProductFailed': 'Failed to load product details',

        // Product Upload Page
        'product.editTitle': 'Edit Product',
        'product.uploadTitle': 'Upload Product',
        'product.editSubtitle': 'Please edit the product information',
        'product.uploadSubtitle': 'Please upload a new product',
        'product.name': 'Game Name',
        'product.nameHint': 'Please enter game name',
        'product.nameRule': 'Within 100 characters',
        'product.price': 'Price(円)',
        'product.priceHint': 'Please enter price',
        'product.priceRule': 'Minimum 0.01',
        'product.description': 'Product Description',
        'product.descriptionHint': 'Please enter detailed product description',
        'product.descriptionRule': 'Within 500 characters',
        'product.image': 'Game product Image',
        'product.imageHint': 'Please select Game product Image',
        'product.selectImage': 'Select Image',
        'product.reSelectImage': 'Re-select Image',
        'product.imageFormatHint': 'Supports JPG, PNG, GIF, WebP formats, maximum 5 MB',
        'product.submitting': 'Uploading...',
        'product.updating': 'Updating...',
        'product.nameRequired': 'Game name is required',
        'product.priceInvalid': 'Price must be at least 0.01',
        'product.imageRequired': 'Game product Image is required',
        'product.fillRequired': 'Please fill in all required fields',
        'product.canOnlyEditOwn': 'You can only edit your own products',
        'product.notExist': 'Product does not exist',
        'product.loadFailed': 'Failed to load product data',
        'product.invalidImage': 'Invalid image format',
        'product.imageTooLarge': 'Image size exceeds 5MB',
        'product.imageReadFailed': 'Failed to read image',
        'product.gameUsername': 'Game Account',
        'product.gameUsernameHint': 'Please enter game account',
        'product.gamePassword': 'Game Password',
        'product.gamePasswordHint': 'Please enter game password',
        'product.gameUsernameRequired': 'Game account is required',
        'product.gamePasswordRequired': 'Game password is required',
        'product.descriptionRequired': 'Product description is required',
        'product.uploadSuccess': 'Product uploaded successfully',
        'product.updateSuccess': 'Product updated successfully',
        'product.imageFormatInvalid': 'Invalid image format. Only JPG, PNG, GIF, WebP are supported',
        'product.removeImage': 'Remove Image',

        // Tips
        'tips.title': 'Tips',
        'tips.reviewRequired': 'Admin review required after submission',
        'tips.updateReviewRequired': 'Re-review required after modification',
        'tips.ensureValid': 'Please ensure product information is valid',
        'tips.statusReset': 'Product status will reset to pending after modification',

        // Profile
        'profile.title': 'User Profile',
        'profile.name': 'Name',
        'profile.phone': 'Phone',
        'profile.bankAccount': 'Bank Account',
        'profile.katakanaName': 'Katakana Name',
        'profile.address': 'Address',
        'profile.balance': 'Balance',
        'profile.save': 'Save',
        'profile.withdrawalSubmitted': 'Withdrawal application submitted',
        'profile.withdrawalFailed': 'Withdrawal application failed',

        // User Profile Page
        'userProfile.title': 'User Profile - Game Trading Platform',
        'userProfile.heading': 'User Profile Management',
        'userProfile.balance': 'Account Balance',
        'userProfile.withdraw': 'Apply for Withdrawal',
        'userProfile.info': 'Personal Information',
        'userProfile.username': 'Username',
        'userProfile.fullName': 'Full Name *',
        'userProfile.fullNameHint': 'Required for withdrawal verification',
        'userProfile.phone': 'Contact Phone *',
        'userProfile.phoneHint': 'For important notifications',
        'userProfile.bankAccount': 'Bank Account *',
        'userProfile.bankAccountHint': 'Used for withdrawals',
        'userProfile.katakanaName': 'Katakana Name *',
        'userProfile.katakanaNameHint': 'For identity verification',
        'profile.email': 'Email',
        'profile.emailPlaceholder': 'Please enter your email',
        'profile.emailHelp': 'Used for important notifications',
        'fundPassword': 'Fund Password *',
        'fundPasswordHelp': 'Please remember the password',
        'fundPasswordHint': 'Used for withdrawals. Please remember password',
        'fundPasswordSet': 'Fund password is set',
        'fundPasswordSetHelp': 'Fund password is properly configured',
        'fundPasswordPlaceholder': 'Enter 8 or more digits and the alphabet password',
        'userProfile.requiredNote': '* Required fields must be completed before withdrawal',
        'userProfile.save': 'Save Profile',
        'userProfile.myProducts': 'My Products',
        'userProfile.noProducts': 'No products yet',
        'userProfile.withdrawalHistory': 'Withdrawal History',
        'userProfile.noWithdrawals': 'No withdrawal records',
        'userProfile.errors.realName': 'Real name is required',
        'userProfile.errors.username': 'Username is required',
        'userProfile.errors.phone': 'Contact phone is required',
        'userProfile.errors.bankAccount': 'Bank account is required',
        'userProfile.errors.katakanaName': 'Katakana name is required',
        'userProfile.errors.fundPassword': 'Fund password is required',
        'userProfile.errors.address': 'Contact address is required',
        'userProfile.errors.bankBranch': 'Bank branch is required',
        'userProfile.errors.bankName': 'Bank name is required',
        'userProfile.errors.email': 'Email is required',


        // Withdrawal
        'withdrawal.title': 'Apply for Withdrawal',
        'withdrawal.amount': 'Amount',
        'withdrawal.bankAccount': 'Bank Account',
        'withdrawal.name': 'Account Name',
        'withdrawal.submit': 'Submit Application',
        'withdrawal.history': 'Withdrawal History',
        'withdrawal.status': 'Status',
        'withdrawal.pending': 'Pending',
        'withdrawal.approved': 'Approved',
        'withdrawal.rejected': 'Rejected',

        // Withdrawal Page
        'withdrawal.pageTitle': 'Apply for Withdrawal',
        'withdrawal.accountInfo': 'Account Information',
        'withdrawal.currentBalance': 'Current Balance:',
        'withdrawal.accountName': 'Account Name:',
        'withdrawal.bankAccountNumber': 'Bank Account:',
        'withdrawal.profileHint': 'To modify account information, please go to',
        'withdrawal.profileLink': 'User Profile',
        'withdrawal.applyTitle': 'Withdrawal Application',
        'withdrawal.amountHint': 'Please enter withdrawal amount (minimum 1 yuan)',
        'withdrawal.notice': 'Important Notes:',
        'withdrawal.notice1': 'Withdrawal amount cannot exceed current balance',
        'withdrawal.notice2': 'Application will enter review process after submission',
        'withdrawal.notice3': 'Funds will arrive within 1-3 business days after approval',
        'withdrawal.notice4': 'If rejected, amount will be returned to account balance',
        'withdrawal.noHistory': 'No withdrawal records',
        'withdrawal.enterAmount': 'Please enter withdrawal amount',
        'withdrawal.enterFundPassword': 'Please enter fund password',

        // Admin
        'admin.dashboard': 'Admin Dashboard',
        'admin.users': 'User Management',
        'admin.products': 'Product Management',
        'admin.withdrawals': 'Withdrawal Management',
        'admin.notifications': 'Notification Management',
        'admin.totalUsers': 'Total Users',
        'admin.totalProducts': 'Total Products',
        'admin.pendingReviews': 'Pending Reviews',
        'admin.dashboardTitle': 'Admin Dashboard',
        'admin.pendingProducts': 'Pending Products',
        'admin.pendingWithdrawals': 'Pending Withdrawals',
        'admin.quickActions': 'Quick Actions',
        'admin.manageUsers': 'Manage Users',
        'admin.manageProducts': 'Manage Products',
        'admin.manageWithdrawals': 'Manage Withdrawals',
        'admin.manageNotifications': 'Manage Notifications',
        'admin.recentActivity': 'Recent Activity',
        'admin.noActivity': 'No recent activity',
        'admin.backToSite': 'Back to Site',

        // User Management
        'users.title': 'User Management',
        'users.username': 'Username',
        'users.name': 'Name',
        'users.status': 'Status',
        'users.balance': 'Balance',
        'users.actions': 'Actions',
        'users.view': 'View',
        'users.freeze': 'Freeze',
        'users.unfreeze': 'Unfreeze',
        'users.active': 'Active',
        'users.frozen': 'Frozen',
        'users.noUsers': 'No users',
        'users.phone': 'Phone',
        'users.userDetails': 'User Details',

        // Product Management
        'productsAdmin.title': 'Product Management',
        'productsAdmin.name': 'Game Name',
        'productsAdmin.price': 'Price',
        'productsAdmin.seller': 'Seller',
        'productsAdmin.status': 'Status',
        'productsAdmin.actions': 'Actions',
        'productsAdmin.view': 'View',
        'productsAdmin.approve': 'Approve',
        'productsAdmin.reject': 'Reject',
        'productsAdmin.pending': 'Pending',
        'productsAdmin.approved': 'Approved',
        'productsAdmin.rejected': 'Rejected',
        'productsAdmin.filterStatus': 'Filter by Status:',
        'productsAdmin.allStatus': 'All',
        'productsAdmin.noProducts': 'No products',
        'productsAdmin.image': 'Image',
        'productsAdmin.productDetails': 'Product Details',

        // Withdrawal Management
        'withdrawalsAdmin.title': 'Withdrawal Management',
        'withdrawalsAdmin.user': 'User',
        'withdrawalsAdmin.amount': 'Amount',
        'withdrawalsAdmin.bankAccount': 'Bank Account',
        'withdrawalsAdmin.status': 'Status',
        'withdrawalsAdmin.actions': 'Actions',
        'withdrawalsAdmin.view': 'View',
        'withdrawalsAdmin.approve': 'Approve',
        'withdrawalsAdmin.reject': 'Reject',
        'withdrawalsAdmin.filterStatus': 'Filter by Status:',
        'withdrawalsAdmin.allStatus': 'All',
        'withdrawalsAdmin.noWithdrawals': 'No withdrawal records',
        'withdrawalsAdmin.accountName': 'Account Name',
        'withdrawalsAdmin.time': 'Application Time',
        'withdrawalsAdmin.withdrawalDetails': 'Withdrawal Details',

        // Notification Management
        'notificationsAdmin.title': 'Notification Management',
        'notificationsAdmin.create': 'Create Notification',
        'notificationsAdmin.contentZh': 'Chinese Content',
        'notificationsAdmin.contentEn': 'English Content',
        'notificationsAdmin.submit': 'Publish',
        'notificationsAdmin.edit': 'Edit',
        'notificationsAdmin.delete': 'Delete',
        'notificationsAdmin.list': 'Notification List',
        'notificationsAdmin.noNotifications': 'No notifications',
        'notificationsAdmin.editTitle': 'Edit Notification',

        // Common
        'common.save': 'Save',
        'common.cancel': 'Cancel',
        'common.confirm': 'Confirm',
        'common.delete': 'Delete',
        'common.edit': 'Edit',
        'common.view': 'View',
        'common.submit': 'Submit',
        'common.back': 'Back',
        'common.loading': 'Loading...',
        'common.success': 'Success',
        'common.error': 'Error',
        'common.required': 'Required',

        // Error Messages
        'error.invalidInput': 'Invalid input',
        'error.usernameExists': 'Username already exists',
        'error.loginFailed': 'Login failed',
        'error.insufficientBalance': 'Insufficient balance',
        'error.incompleteProfile': 'Please complete your profile first',
        'error.fundPasswordRequired': 'Please set up fund password first',
        'error.invalidImage': 'Invalid image format',
        'error.unauthorized': 'Unauthorized access',

        // Product Edit Messages
        'profile.productSold': 'This product has been sold and cannot be edited',
        'profile.productRemoved': 'This product has been removed and cannot be edited',
        'profile.completeProfileFirst': 'Please complete your profile first',
        'profile.accountFrozen': 'Your account is frozen. Please contact support',
        'profile.checkUserStatusFailedRetry': 'Failed to check user status. Please try again later',
        'profile.completeProfileFirst': 'Please complete your profile first',
        'profile.insufficientBalance': 'Your balance is insufficient. Please recharge your account',
        'profile.fundPasswordRequired': 'Fund password is required. Please set up fund password first',
        'profile.withdrawalSubmitted': 'Withdrawal application submitted',
        'profile.saveFailed': 'Profile saving failed.',
        'profile.saveFailedRetry': 'Profile saving failed. Please try again later',

        // Custom Registration Error Messages
        'register.usernameInvalid': 'Username format is incorrect, only letters, numbers and underscores allowed, length 3-20 characters',
        'register.usernameExists': 'Username already exists',
        'register.passwordInvalid': 'Password format is incorrect, at least 8 characters, must contain numbers and letters',
        'register.networkError': 'Network error, please try again later',
        'register.serverError': 'Server error, please try again later',
        'register.unknownError': 'Registration failed, please try again later',
    }
}

/**
 * 国际化工具类
 */
class I18n {
    constructor() {
        // 从LocalStorage读取语言设置，默认为日语
        const settings = storage.get('settings')
        this.currentLanguage = (settings && settings.language) || 'ja'
    }

    /**
     * 翻译文本
     * @param {string} key - 翻译键名
     * @returns {string} 翻译后的文本，如果找不到则返回键名
     */
    t(key) {
        const langDict = translations[this.currentLanguage]
        if (langDict && langDict[key]) {
            return langDict[key]
        }
        // 如果找不到翻译，返回键名
        return key
    }

    /**
     * 设置语言
     * @param {string} lang - 语言代码 ('ja', 'zh' 或 'en')
     */
    setLanguage(lang) {
        if (lang !== 'ja' && lang !== 'zh' && lang !== 'en') {
            console.error('Invalid language:', lang)
            return
        }

        this.currentLanguage = lang

        // 保存到LocalStorage
        const settings = storage.get('settings') || {}
        settings.language = lang
        storage.set('settings', settings)

        // 触发全局事件通知组件更新
        if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent('languageChanged', { detail: lang }))
        }
    }

    /**
     * 获取当前语言
     * @returns {string} 当前语言代码
     */
    getLanguage() {
        return this.currentLanguage
    }
}

// 创建单例实例
const i18n = new I18n()

export default i18n
